export const FIL = {
  "Open document": "Buksan ang dokumento",
  "Upload file": "Mag-upload ng file",
  "Drop file here to upload": "I-drop ang file dito upang mai-upload",
  "Disc": "Disc",
  "URL": "URL",
  "FILE": "FILE",
  "SIZE": "SIZE",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "Mga byte",
  "Loading... Please wait.": "Naglo-load ... Mangyaring maghintay.",
  "Fit Width": "Pagkasyahin ang Lapad",
  "Fit Height": "Pagkasyahin sa Taas",
  "Password protected document": "Dokumentong protektado ng password",
  "Password": "Password",
  "Open": "Buksan",
  "Password Required": "Kailangan ng password",
  "Incorrect password": "Maling password",
  "Error": "Error",
  "Something went wrong": "May nangyaring mali",
  "Server is not available": "Hindi magagamit ang server",
  "of": "ng",
  "Please wait...": "Mangyaring maghintay ..."
};
